import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';
import { Button } from '../ui/Button';
interface ValidationScreenProps {
  onContinue: () => void;
}
export function ValidationScreen({
  onContinue
}: ValidationScreenProps) {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.25,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 16
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <div className="flex flex-col h-full flex-1 items-center justify-center text-center py-6" data-id="element-316">
      <motion.div initial={{
      scale: 0
    }} animate={{
      scale: 1
    }} transition={{
      type: 'spring',
      stiffness: 200,
      damping: 15
    }} className="w-20 h-20 bg-red-50 rounded-full flex items-center justify-center mb-6 relative" data-id="element-317">
        <motion.div animate={{
        scale: [1, 1.15, 1]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-318">
          <Heart className="text-red-400" size={40} fill="currentColor" data-id="element-319" />
        </motion.div>
        <motion.div animate={{
        scale: [1, 1.5],
        opacity: [0.5, 0]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeOut'
      }} className="absolute inset-0 bg-red-100 rounded-full -z-10" data-id="element-320" />
      </motion.div>

      <motion.div variants={containerVariants} initial="hidden" animate="visible" className="w-full max-w-sm" data-id="element-321">
        <motion.h2 variants={itemVariants} className="text-interstitial-h2 md:text-interstitial-h2-desktop font-heading font-bold text-brand-dark mb-6 text-center" data-id="element-322">
          Si has probado de todo, esta puede ser la razón.
        </motion.h2>

        <div className="space-y-4 text-interstitial-body text-gray-600 leading-relaxed mb-8 text-center" data-id="element-323">
          <motion.p variants={itemVariants} data-id="element-324">
            Muchos consejos funcionan bien en teoría, pero fallan cuando el niño
            está cansado, frustrado o sobreestimulado.
          </motion.p>
          <motion.p variants={itemVariants} className="font-heading font-bold text-brand-blue text-interstitial-h2" data-id="element-325">
            No has fallado.
          </motion.p>
          <motion.p variants={itemVariants} data-id="element-326">
            A veces solo falta convertir las recomendaciones en pasos pequeños,
            repetibles y fáciles de aplicar en medio del caos.
          </motion.p>
        </div>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 1.3,
      duration: 0.45
    }} className="mt-auto w-full pt-3 pb-safe" data-id="element-327">
        <Button onClick={onContinue} data-id="element-328">Entiendo, continuar</Button>
      </motion.div>
    </div>;
}